// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#typography .small-text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  #typography .small-text {
    font-size: 9rem;
  }
}
#typography .medium-text {
  color: #fff;
  font-size: 15rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 660px) {
  #typography .medium-text {
    font-size: 12rem;
  }
}
#typography .sub-title {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #typography .sub-title {
    font-size: 17rem;
  }
}
#anim .reveal[visible] {
  opacity: 1;
  transform: translateX(0) translateY(0) rotate(0deg);
}
.section {
  position: relative;
  padding: 71rem 99rem 0;
  margin-bottom: 72rem;
}
@media (max-width: 660px) {
  .section {
    padding: 81rem 30rem 27rem;
  }
}
.section__title {
  color: #fff;
  /* H1 Headline */
  font-size: 28rem;
  font-style: normal;
  font-weight: 600;
  margin-bottom: 28rem;
  opacity: 0;
  transition: 0.6s opacity, 0.6s transform;
  transform: translateY(20rem);
}
@media (max-width: 660px) {
  .section__title {
    margin: 0 0 44rem;
    font-size: 25rem;
    line-height: 31rem;
  }
}
.section__desc {
  width: 100%;
  color: #fff;
  font-size: 15rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  opacity: 0;
  transition: 0.6s opacity, 0.6s transform;
  transition-delay: 0.2s;
  transform: translateY(20rem);
}
@media (max-width: 660px) {
  .section__desc {
    font-size: 12rem;
  }
}
@media (max-width: 660px) {
  .section__desc {
    font-size: 20rem;
    line-height: 32rem;
  }
}
.main.loaded-done .section__desc[visible] {
  opacity: 1;
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/mixins.style.less","webpack://./src/shared/ui/Section/Section.style.less"],"names":[],"mappings":"AAAA;EAEQ,WAAA;ECAN,WAAW;EDEL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACAR;ADEQ;EAAA;IACI,eAAA;ECCV;AACF;ADbA;EAgBQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACAR;ADCQ;EAAA;IACI,gBAAA;ECEV;AACF;ADzBA;EA2BQ,WAAA;ECCN,gBAAgB;EDCV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACCR;ADAQ;EAAA;IACI,gBAAA;ECGV;AACF;ADUQ;EACI,UAAA;EACA,mDAAA;ACRZ;AAxCA;EACI,kBAAA;EACA,sBAAA;EACA,oBAAA;AA0CJ;AAvCA;EACI;IACI,0BAAA;EAyCN;AACF;AAtCA;EACI,WAAA;EAwCF,gBAAgB;EAtCd,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,wCAAA;EACA,4BAAA;AAwCJ;AArCA;EACI;IACI,iBAAA;IACA,gBAAA;IACA,kBAAA;EAuCN;AACF;AApCA;EACI,WAAA;EDnBI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ECiBJ,UAAA;EACA,wCAAA;EACA,sBAAA;EACA,4BAAA;AA0CJ;AD7DQ;EAAA;IACI,gBAAA;ECgEV;AACF;AA5CA;EACI;IACI,gBAAA;IACA,kBAAA;EA8CN;AACF;AA3CA;EACI,UAAA;EACA,wBAAA;AA6CJ","sourcesContent":["#typography {\n    .small-text {\n        color: #fff;\n        /* Text 1 */\n        font-size: 12rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: 0.2rem;\n\n        @media (max-width: 660px) {\n            font-size: 9rem;\n        }\n    }\n\n    .medium-text {\n        color: #fff;\n        font-size: 15rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        @media (max-width: 660px) {\n            font-size: 12rem;\n        }\n    }\n\n    .sub-title {\n        color: #fff;\n        /* H1 Headline */\n        font-size: 20rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 32px;\n        @media (max-width: 660px) {\n            font-size: 17rem;\n        }\n    }\n}\n\n#anim {\n    .defaultOpacityTransforms(@delay: 0s, @transform: translateY(0rem)) {\n        transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;\n        transition-delay: @delay;\n        transform: @transform;\n        opacity: 0;\n    }\n\n    .reveal {\n        &[visible] {\n            opacity: 1;\n            transform: translateX(0) translateY(0) rotate(0deg);\n        }\n    }\n}","@import 'mixins.style.less';\n\n.section {\n    position: relative;\n    padding: 71rem 99rem 0;\n    margin-bottom: 72rem;\n}\n\n@media (max-width: 660px) {\n    .section {\n        padding: 81rem 30rem 27rem;\n    }\n}\n\n.section__title {\n    color: #fff;\n    /* H1 Headline */\n    font-size: 28rem;\n    font-style: normal;\n    font-weight: 600;\n    margin-bottom: 28rem;\n    opacity: 0;\n    transition: .6s opacity, .6s transform;\n    transform: translateY(20rem);\n}\n\n@media (max-width: 660px) {\n    .section__title {\n        margin: 0 0 44rem;\n        font-size: 25rem;\n        line-height: 31rem;\n    }\n}\n\n.section__desc {\n    width: 100%;\n    #typography.medium-text();\n    opacity: 0;\n    transition: .6s opacity, .6s transform;\n    transition-delay: .2s;\n    transform: translateY(20rem);\n}\n\n@media (max-width: 660px) {\n    .section__desc {\n        font-size: 20rem;\n        line-height: 32rem;\n    }\n}\n\n.main.loaded-done .section__desc[visible] {\n    opacity: 1;\n    transform: translateY(0);\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
